import React, { useState, useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { Navbar } from './Navbar';
import './Dashboard.css';

export function DashboardLayout({ children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const [sidebarOpen, setSidebarOpen] = useState(false); // New state for mobile open/close

  const checkIfMobile = () => {
    const mobile = window.innerWidth <= 992;
    setIsMobile(mobile);
    if (!mobile) {
      setSidebarOpen(false); // Reset when resizing to desktop
    }
  };

  useEffect(() => {
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const toggleSidebar = () => {
    if (isMobile) {
      // Mobile pe toggle between open/close
      setSidebarOpen(!sidebarOpen);
    } else {
      // Desktop pe toggle between collapsed/expanded
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar 
        collapsed={isMobile ? false : sidebarCollapsed} 
        isMobile={isMobile}
        isOpen={sidebarOpen}
        onToggle={toggleSidebar} 
      />
      <div className={`main-content ${sidebarCollapsed && !isMobile ? 'collapsed' : ''}`}>
        <Navbar onToggleSidebar={toggleSidebar} isMobile={isMobile} />
        <main className="content-wrapper">
          {children}
        </main>
      </div>
    </div>
  );
}